import {
  CampaignDto,
  CampaignsListQuery,
  AddCampaignCommand,
  UpdateCampaignCommand,
  DeleteCampaignCommand,
  HideCampaignForAllUsersCommand,
} from 'store/models/campaign';
import {api} from './api';

export const injectedCampaignsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCampaigns: builder.query<CampaignDto[], CampaignsListQuery>({
      query: (params) => ({
        url: 'campaigns/list', // [cite: 2281]
        method: 'GET',
        params: params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({id}) => ({type: 'Campaigns' as const, id})),
              'Campaigns',
            ]
          : ['Campaigns'],
    }),

    getCampaignsByUser: builder.query<CampaignDto[], {userId: string}>({
      query: ({userId}) => ({
        url: `campaigns/get-active-campaigns`, // [cite: 2312]
        params: {id: userId}, // Предполагаемый эндпоинт
        method: 'GET',
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({id}) => ({type: 'Campaigns' as const, id})),
              'Campaigns',
            ]
          : ['Campaigns'],
    }),

    addCampaign: builder.mutation<CampaignDto, AddCampaignCommand>({
      query: (command) => {
        console.log(command);

        return {
          url: 'campaigns/add-campaign', // [cite: 2290]
          method: 'POST',
          data: command,
        };
      },
      invalidatesTags: ['Campaigns'], // Обновляем список кампаний
    }),

    // 3. PUT /api/campaigns/update-campaign (Обновить кампанию)
    // Эндпоинт предполагается на основе наличия UpdateCampaignCommand
    updateCampaign: builder.mutation<void, UpdateCampaignCommand>({
      query: (command) => ({
        url: 'campaigns/update-campaign', // Предполагаемый PUT эндпоинт
        method: 'PUT',
        data: command,
      }),
      // Инвалидируем конкретную кампанию по ID и список
      invalidatesTags: (result, error, arg) => [
        {type: 'Campaigns', id: arg.campaignId},
        'Campaigns',
      ],
    }),

    // 4. DELETE /api/campaigns/delete-campaign (Удалить кампанию)
    deleteCampaign: builder.mutation<void, DeleteCampaignCommand>({
      query: (command) => ({
        url: 'campaigns/delete-campaign', // [cite: 2298]
        method: 'DELETE',
        data: command,
      }),
      invalidatesTags: (result, error, arg) => [
        {type: 'Campaigns', id: arg.id},
      ],
    }),

    // 5. PATCH /api/campaigns/hide-for-all-users (Скрыть кампанию)
    hideCampaignForAllUsers: builder.mutation<
      void,
      HideCampaignForAllUsersCommand
    >({
      query: (command) => ({
        url: 'campaigns/hide-for-all-users', // [cite: 2305]
        method: 'PATCH',
        data: command,
      }),
      // Инвалидируем конкретную кампанию, так как ее статус меняется
      invalidatesTags: (result, error, arg) => [
        {type: 'Campaigns', id: arg.id},
      ],
    }),

    unHideCampaignForAllUsers: builder.mutation<
      void,
      HideCampaignForAllUsersCommand
    >({
      query: (command) => ({
        url: 'campaigns/unhide-for-all-users', // Предполагаемый эндпоинт
        method: 'PATCH',
        data: command,
      }),
      // Инвалидируем конкретную кампанию, так как ее статус меняется
      invalidatesTags: (result, error, arg) => [
        {type: 'Campaigns', id: arg.id},
      ],
    }),

    hideCampaignForUser: builder.mutation<
      void,
      {campaignId: number; userId: string}
    >({
      query: ({campaignId, userId}) => ({
        url: 'campaigns/hide-campaign-for-user', // Предполагаемый эндпоинт
        method: 'PATCH',
        data: {id: campaignId},
      }),
      // Инвалидируем конкретную кампанию для обновления ее статуса
      invalidatesTags: (result, error, arg) => [
        {type: 'Campaigns', id: arg.campaignId},
      ],
    }),

    unHideCampaignForUser: builder.mutation<
      void,
      {campaignId: number; userId: string}
    >({
      query: ({campaignId, userId}) => ({
        url: 'campaigns/unhide-campaign-for-user', // Предполагаемый эндпоинт
        method: 'PATCH',
        data: {id: campaignId},
      }),
      // Инвалидируем конкретную кампанию для обновления ее статуса
      invalidatesTags: (result, error, arg) => [
        {type: 'Campaigns', id: arg.campaignId},
      ],
    }),
  }),
  overrideExisting: false,
});

// Экспортируем сгенерированные хуки для использования в компонентах
export const {
  useGetCampaignsByUserQuery,
  useGetCampaignsQuery,
  useAddCampaignMutation,
  useUpdateCampaignMutation,
  useDeleteCampaignMutation,
  useHideCampaignForAllUsersMutation,
  useUnHideCampaignForAllUsersMutation,
  useHideCampaignForUserMutation,
  useUnHideCampaignForUserMutation,
} = injectedCampaignsApi;
